module.exports = __webpack_public_path__ + "static/media/image_12.d7b45a8a.png";